import { render, staticRenderFns } from "./mailling-item.vue?vue&type=template&id=7f3979c2&scoped=true"
import script from "./mailling-item.vue?vue&type=script&lang=js"
export * from "./mailling-item.vue?vue&type=script&lang=js"
import style0 from "./mailling-item.vue?vue&type=style&index=0&id=7f3979c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3979c2",
  null
  
)

export default component.exports